module.exports = __webpack_public_path__ + "static/media/icon_history.0ebb9c89.svg";